import {
  MENU_CATEGORY_KEYS,
  type PermissionMap,
  type PermissionValue,
} from '../types/role.types';

const RANK: Record<PermissionValue, number> = {
  NO_PERMISSION: 0,
  READ: 1,
  WRITE: 2,
};

// Returns true if `after` has at least one category at a strictly lower
// permission level than `before`. Used to trigger the PRD §3.3
// permission-reduction confirmation when editing a role currently held
// by one or more admins.
export function isPermissionReduced(before: PermissionMap, after: PermissionMap): boolean {
  return MENU_CATEGORY_KEYS.some((cat) => RANK[after[cat]] < RANK[before[cat]]);
}
